import { Injectable } from '@angular/core';
import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

@Injectable()
export class SampleSearchService {

    constructor( ) {
    }

    public validateContainerNo(containerNo: number) {
        if (!containerNo) {
            return 'Container No cannot be empty.';
        }

        if (isNaN(containerNo) || +containerNo > 999) {
            return 'Container No should be 0 - 999';
        }
        return null;
    }

    public getAccessionAndContainerNo(value: any, accessionNo: string, containerNo: number) {
        if (value.length > 7 && value.length <= 10) {
            accessionNo = value.slice(0, 7);
            containerNo = value.slice(7);
        }

        if (value.length > 10) {
            accessionNo = value.slice(0, 10);
            containerNo = value.slice(10);
        }
        return { accessionNo, containerNo };
    }
}


export function accessionNoValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value.trim();

        if (!value) {
            return null;
        }

        if (value && !(/^[a-zA-Z0-9]*$/.test(value))) {
            return { validation: 'Accession should be AlphaNumeric' };
        }

        if (value && (value.length === 7 || value.length === 10)) {
            return null;
        }

        return { validation: 'Accession should be 7 digits or 10 digits' };
    };
}

export function accessionNoAndContainerValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value.trim();

        if (!value) {
            return null;
        }

        if (value && !(/^[a-zA-Z0-9-]*$/.test(value))) {
            return { validation: 'Accession should be AlphaNumeric' };
        }

        if (value && (value.length > 7 && value.length <= 14)) {
            return null;
        }

        return { validation: 'Enter valid Accession + Container No to search' };
    };
}